export default "__VITE_ASSET__BG474luL__"